"use client";

import { useRef, useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import LoadingBar, { LoadingBarRef } from "react-top-loading-bar";

export function TopLoadingBar() {
  const ref = useRef<LoadingBarRef>(null);
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Start the loading bar when navigation begins
    ref.current?.continuousStart();

    // This effect runs after the page has fully loaded/hydrated
    const handleComplete = () => {
      ref.current?.complete();
    };

    // Execute handleComplete on the next tick after component mount/update
    // which happens after navigation is complete
    const timeoutId = setTimeout(handleComplete, 0);

    return () => clearTimeout(timeoutId);
  }, [pathname, searchParams]);

  return (
    <LoadingBar
      ref={ref}
      height={2}
      shadow={true}
      color="hsl(var(--brand-primary))"
    />
  );
}
